/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Board1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Board from './Board/index'
import React from 'react'
import TasksFilters from 'DesignSystem/TasksFilters/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Board1({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let tabSelectedBoardIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_id',
})
let filtersValueData = fromData.useDataValue({ viewPath,
context: 'filters',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Board.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-4Dwm1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-4Dwm1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-4Dwm1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-4Dwm1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TasksFilters
  viewPath={`${viewPath}/TasksFilters`}
 onChange={onChange}
 data="tab.selected.board_id"
 boardId={tabSelectedBoardIdValueData}
 data="filters"
 syncFilters={filtersValueData}
/>
</div>
<Board
  viewPath={`${viewPath}/Board`}
/>
{children}
</React.Fragment>)
}